module.exports={
	"@metadata": {
		"author": "Miguel Ceriani <miguel.ceriani@gmail.com>",
		"locale": "en",
		"messagedocumentation" : "qqq"
	},
	"VERB_OBJECT_TOOLTIP": "Match outbound triples with specified predicate (variable or resource) and object (variable, resource, or literal).",
	"REVERSEPATH_OBJECT_TOOLTIP": "Match inbound triples with specified predicate (resource) and subject (variable or resource).",
	"CLOSUREPATH_OBJECT_TOOLTIP": "Match outbound paths of any length with specified predicate (resource) ad object (variable, resource, or literal).",
	"REVERSECLOSUREPATH_OBJECT_TOOLTIP": "Match inbound paths of any length with specified predicate (resource) ad subject (variable or resource).",
	"TYPEDSUBJECT_PROPERTYLIST_TOOLTIP": "Match graphs from a specified node (variable or resource), optionally of a specified type (variable or resource).",
	"ANONSUBJECT_PROPERTYLIST_TOOLTIP": "Match graphs from current node.",
	"ISA_TOOLTIP": "Match a specified type (variable or resource).",
	"FILTER_TOOLTIP": "Require the specified expression to be true.",
	"UNION_TOOLTIP": "Get the matchings of both sub-groups.",
	"OPTIONAL_TOOLTIP": "Consider the matching of this sub-group as optional",
	"GRAPH_TOOLTIP": "For datasets with multiple graphs, choose a specific graph by its name (a resource).",
	"SELECT_TOOLTIP": "Select Query: get the variable bindings as a table, ordered and with a max number of rows.",
	"EXECUTION_TOOLTIP": "Execute a query against a SPARQL endpoint. Results are shown as a table below the query",
	"PREFIXED_IRI_TOOLTIP": "A resource, in prefix notation.",
	"IRI_TOOLTIP": "A resource, represented with full IRI.",
	"EXISTS_TOOLTIP": "Require that the sub-group is matched at least once.",
	"NOT_EXISTS_TOOLTIP": "Require that the sub-group is never matched.",
	"TEXT_TOOLTIP": "A string literal.",
	"TEXT_WITH_LANG_TOOLTIP": "A string literal, in the specified language (IANA language tag or subtag).",
	"TEXT_WITH_TYPE_PREF_TOOLTIP": "A typed literal.",
	"TEXT_WITH_TYPE_IRI_TOOLTIP": "A typed literal.",
	"MATH_NUMBER_TOOLTIP": "A numeric literal.",
	"TABLE_TOOLTIP": "Table of query results. You can use the result values as blocks in queries!",
	"LOGIC_BOOLEAN_TOOLTIP": "A boolean literal.",
	"EXECUTION_IN_PROGRESS": "execution in progress...",
	"EXECUTION_IN_PROGRESS_TOOLTIP": "The server is taking a while. You can still build and launch queries in the meanwhile...",
	"EXECUTION_PLACEHOLDER": " < results will appear here > ",
	"EXECUTION_PLACEHOLDER_TOOLTIP": "After you make a query, a table with the results will show up here.",
	"EXECUTION_CONNECTION_ERROR": "Connection Error!",
	"HASH_TOOLTIP": "Apply a hash function."
}
